import { createClient } from "@supabase/supabase-js";
import { processLock } from "@supabase/auth-js/dist/module/lib/locks";

/* Single Supabase client for the whole app.

   We use `processLock` (in-tab, in-memory) rather than the default
   `navigatorLock`. The default lock is browser-wide and, with an infinite
   acquire timeout, can deadlock across:
     - hard-reload boundaries (a fresh GoTrueClient waits on an old realm's
       lock that was never released),
     - simultaneous tabs on the same origin,
     - stalled auto-refresh cycles.

   That deadlock blocks the `INITIAL_SESSION` event from firing, which was the
   real cause of the recurring "stuck on Loading" / login-loop bug.

   Trade-off with processLock: two SalesPit tabs open at once could each
   attempt a token refresh concurrently. The auth server tolerates that — a
   refresh token has a short grace window during which duplicate exchanges
   return the same session. */

export const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: "pkce",
      lock: processLock,
    },
  }
);

/* Test hook — exposes the app's shared Supabase client so E2E tests can call
   supabase.auth.signInWithPassword() without going through Google OAuth. It's
   the same anon-key client the app already uses; safe to keep in production. */
if (typeof window !== "undefined") window.__sb__ = supabase;
